var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import id from "@irati/utils/id";
import { get } from "lodash";
import { connect } from "@irati/store";
import { walletTracking } from "@irati-tracking/wallet";
import authentication from "@irati/auth";
import { injectIntl } from "@irati/utils/lang";
import PerksGOBanner from "@irati-web/perksgo/src/components/WalletBanner";
import WalletActions from "@irati/wallet/store/actions/Wallet";
import Intro from "../../components/Intro";
import AvailableBalance from "../../components/AvailableBalance";
import Transactions from "../../components/Transactions";
import FAQs from "../../components/FAQs";
import SendCreditSuccessModal from "../../components/SendCreditSuccessModal";
import Container from "../styled/Container";
export var TabTypes;
(function (TabTypes) {
    TabTypes["Cleared"] = "cleared";
    TabTypes["Pending"] = "pending";
    TabTypes["Cancelled"] = "cancelled";
})(TabTypes || (TabTypes = {}));
var Wallet = /** @class */ (function (_super) {
    __extends(Wallet, _super);
    function Wallet(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCloseModal = function () {
            _this.setState({ recipient: null });
        };
        _this.handleTabChange = function (selectedTab) {
            _this.setState({ selectedTab: selectedTab });
        };
        _this.state = {
            recipient: get(props, "location.state.recipient"),
            amount: get(props, "location.state.amount"),
            selectedTab: TabTypes.Cleared
        };
        return _this;
    }
    Wallet.prototype.componentDidMount = function () {
        var _a = this.props, getWallet = _a.getWallet, wallet = _a.wallet;
        var requested = wallet.requested;
        if (!requested) {
            getWallet();
        }
        walletTracking.viewHome();
    };
    Wallet.prototype.render = function () {
        var _a = this.state, recipient = _a.recipient, amount = _a.amount, selectedTab = _a.selectedTab;
        var idNamespace = id("wallet", this.props, { force: true });
        return (React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, { md: 6, lg: 7 },
                    React.createElement(Intro, { id: idNamespace })),
                React.createElement(Col, { md: 6, lg: 5 },
                    React.createElement(AvailableBalance, { id: idNamespace }))),
            authentication.apps("perks.perksGo") && (React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(PerksGOBanner, { id: idNamespace })))),
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(Transactions, { id: idNamespace, selectedTab: selectedTab, onTabChange: this.handleTabChange }))),
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(FAQs, { id: idNamespace, selectedTab: selectedTab }))),
            !!recipient && React.createElement(SendCreditSuccessModal, { recipient: recipient, value: amount, onClose: this.handleCloseModal })));
    };
    return Wallet;
}(Component));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({
        wallet: wallet
    });
};
var mapDispatchToProps = function (dispatch) {
    return {
        getWallet: function () { return dispatch(WalletActions.get()); }
    };
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Wallet));
